import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=60e0216c&scoped=true&lang=pug&"
import script from "./InputFile.vue?vue&type=script&lang=ts&"
export * from "./InputFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0216c",
  null
  
)

export default component.exports